import { GraduationCap, Lightbulb, Rocket, Users2, Sparkles } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const competenze = [
  {
    icon: Rocket,
    title: "Strategia & Business",
    text: "Progettazione di nuove iniziative, modelli di business, partnership e percorsi di crescita.",
  },
  {
    icon: Sparkles,
    title: "Digital & Innovazione",
    text: "Trasformazione digitale, AI, MarTech, ecosistemi phygital e sperimentazione.",
  },
  {
    icon: Users2,
    title: "Formazione & Talenti",
    text: "Didattica esperienziale, coordinamento di percorsi, connessione tra competenze e impresa.",
  },
  {
    icon: Lightbulb,
    title: "Innovation Management",
    text: "Progetti di digitalizzazione e nuovi modelli organizzativi — qualificato MISE.",
  },
];

export const Docente = () => (
  <section id="docente" className="relative bg-white py-24 sm:py-32" data-testid="docente-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-start lg:gap-16">
        {/* Left column: identity card */}
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>Il docente</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="mt-6 flex items-center gap-5">
              <div className="relative flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-[#0E1A4A] shadow-[0_12px_40px_-16px_rgba(14,26,74,0.6)]">
                <GraduationCap className="h-11 w-11 text-[#C9A227]" strokeWidth={1.6} />
                <span className="absolute bottom-1.5 right-1.5 h-2.5 w-2.5 rounded-full bg-[#C9A227]" />
              </div>
              <div>
                <p className="font-display text-2xl font-black uppercase leading-tight tracking-tight text-[#16256B] sm:text-3xl">
                  Francesco G.<br />Lamacchia
                </p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="mt-6 space-y-2">
              <span className="inline-flex items-center rounded-full border border-[#E4E8F2] bg-[#F7F9FD] px-3 py-1 font-body text-xs font-semibold text-[#16256B]">
                Founder dot Academy
              </span>{" "}
              <span className="inline-flex items-center rounded-full border border-[#E4E8F2] bg-[#F7F9FD] px-3 py-1 font-body text-xs font-semibold text-[#16256B]">
                Innovation Manager qualificato MISE
              </span>{" "}
              <span className="inline-flex items-center rounded-full border border-[#E4E8F2] bg-[#F7F9FD] px-3 py-1 font-body text-xs font-semibold text-[#16256B]">
                Docente universitario
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="mt-8 font-body text-base leading-relaxed text-[#4A5268]">
              Imprenditore della formazione, consulente di innovazione e docente
              universitario in <strong className="text-[#16256B]">Digital Marketing, Business Management e
              Marketing Technology</strong>.
            </p>
            <p className="mt-4 font-body text-base leading-relaxed text-[#4A5268]">
              Negli ultimi dieci anni ha progettato ecosistemi formativi certificati,
              portato VR/AR e intelligenza artificiale nei percorsi di EdTech e
              accompagnato imprese e persone nei processi di trasformazione digitale.
              Il suo approccio connette <strong className="text-[#16256B]">persone, tecnologia e strategia</strong>
              {" "}per trasformare le idee in progetti concreti.
            </p>
          </Reveal>
        </div>

        {/* Right column: competenze grid */}
        <div className="lg:col-span-7">
          <Reveal delay={0.12}>
            <p className="font-body text-xs uppercase tracking-overline text-[#2D46A0]">Aree di competenza</p>
            <h3 className="mt-3 font-display text-3xl font-black uppercase leading-tight tracking-tight text-[#16256B] sm:text-4xl">
              Dove la strategia incontra la didattica.
            </h3>
          </Reveal>

          <div className="mt-10 grid gap-5 sm:grid-cols-2">
            {competenze.map((c, i) => (
              <Reveal
                key={c.title}
                delay={0.1 + i * 0.08}
                className="group rounded-2xl border border-[#E4E8F2] bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#16256B]/20 hover:shadow-[0_18px_50px_-24px_rgba(22,37,107,0.35)]"
                data-testid={`competenza-${i}`}
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#16256B]/5">
                  <c.icon className="h-5 w-5 text-[#16256B]" strokeWidth={1.75} />
                </span>
                <h4 className="mt-5 font-display text-lg font-extrabold text-[#16256B]">
                  {c.title}
                </h4>
                <p className="mt-2 font-body text-sm leading-relaxed text-[#4A5268]">
                  {c.text}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.35}>
            <p className="mt-8 font-body text-sm italic text-[#8A93A8]">
              &ldquo;Connettere persone, tecnologia e strategia per trasformare le idee in progetti concreti.&rdquo;
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
